// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ib-0";